/* eslint-disable */
import { isClient } from "@app/../../packages/utils/src/general";
import { getScript } from "@kikoff/client-utils/src/dom"

if (isClient && process.env.REALLY_PRODUCTION) {
  getScript("//dynamic.criteo.com/js/ld/ld.js?a=112298")
}
